import React from 'react'
   
const Layout =({children}) =>{
    return(
        <div className="bg-white font-sans">{children}</div>
    )
}
   
export default Layout;